import { Component, computed, input, output, Signal } from '@angular/core';
import { PaginationStore } from '../../../stores/pagination-store.service';
import { ButtonComponent, IconComponent } from '@webapp/ui';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [ButtonComponent, IconComponent],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
})
export class PaginationComponent {
  paginationStore = input.required<PaginationStore>();

  pageChange = output<void>();

  windowSize = this.isMobile() ? 1 : 5;

  isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  get currentPage() {
    return this.paginationStore().getCurrentPage();
  }

  get totalPages() {
    return this.paginationStore().getPages();
  }

  get pages(): Signal<number[]> {
    return computed(() => {
      const halfWindow = Math.floor(this.windowSize / 2);
      const currentPage = this.currentPage();
      const totalPages = this.paginationStore().getPages()();

      if (this.windowSize > totalPages) {
        return this.range(totalPages);
      }

      const startPage = currentPage - halfWindow;

      if (currentPage > totalPages - this.windowSize) {
        return this.range(
          this.windowSize,
          Math.max(totalPages - this.windowSize, 0)
        );
      }

      if (currentPage < this.windowSize - 1) {
        return this.range(this.windowSize);
      }

      return this.range(this.windowSize, startPage);
    });
  }

  range(n: number, start = 0): number[] {
    return Array.from({ length: n }, (_, i) => i + start);
  }

  changePage(page: number) {
    if (page == this.currentPage()) return;
    this.paginationStore().setCurrentPage(page);
    this.pageChange.emit();
  }
}
